module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Folder_16"],"path":[{"$":{"d":"M15,14H1V5H15ZM7,2H1V4H9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Folder_16.svg
// module id = m7+/
// module chunks = 1